const convertPxToNumber = (px) => {
  return parseFloat(px);
};

export default convertPxToNumber;
